module.exports = __webpack_public_path__ + "img/imgs3.2b16b26c.png";